import axios from '@/lib/axios';
import { PurchaseOrderComment } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 0632. 発注案件コメント編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/purchase_order_comments/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  id: number;
  content: string;
  content_json: string;
};
const updatePurchaseOrderComment = (props: Props): Promise<PurchaseOrderComment> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/purchase_order_comments/${props.id}`,
    props
  );
};

export const useUpdatePurchaseOrderComment = () => {
  return useMutation({
    mutationFn: updatePurchaseOrderComment,
  });
};
